<template>
    <div class="popup" :class="classObj">
        <van-popup v-model="show" @click-overlay="close">
            <div class="icon-close" @click="close">
                <i class="iconfont icon-s-cuowu-guanbi"></i>
            </div>
            <div class="content">
                <div class="header">
                    <div class="title">
                        <div class="img">
                            <img src="@/assets/deposit/newDeposit.png" />
                        </div>
                        <div>{{ $t("deposit.DepositBonus") }}</div>
                    </div>
                    <div class="desc">{{ $t("deposit.DepositTips") }}</div>
                </div>
                <div class="main-content">
                    <div class="btn" @click="toDeposit">{{ $t("deposit.Deposit") }}</div>
                    <div v-if="RechargeList && RechargeList.length" class="table">
                        <div>{{ $t('deposit.OnlineDeposit') }}</div>
                        <div class="table-header">
                            <div>{{ $t("deposit.DepositAmount") }}</div>
                            <div>{{ $t("deposit.Bonus") }}</div>
                        </div>
                        <div class="table-body">
                            <div class="tr" v-for="(item, index) in RechargeList" :key="index">
                                <div>{{ CurrencyType }} {{ item.rechargeAmt }}</div>
                                <div>
                                    <!-- <div v-if="item.extraMoney" class="extra">+{{ CurrencyType }} {{ item.extraMoney }}</div> -->
                                    <div v-if="item.bonusPercent" class="extra">+{{ item.bonusPercent }}%</div>
                                </div>
                                <div v-if="item.freePayNumber && repeatIsFreeRounds == 'Yes'" class="extra">+{{ item.freePayNumber }}FS</div>
                            </div>
                        </div>
                    </div>
                    <div v-if="usdtList && usdtList.length" class="table">
                        <div>{{ $t('deposit.TransferDeposit') }}</div>
                        <div class="table-header">
                            <div>{{ $t("deposit.DepositAmount") }}</div>
                            <div>{{ $t("deposit.Bonus") }}</div>
                        </div>
                        <div class="table-body">
                            <div class="tr" v-for="(item, index) in usdtList" :key="index">
                                <div>U {{ item.rechargeAmt }}</div>
                                <div>
                                    <!-- <div v-if="item.extraMoney" class="extra">+{{ CurrencyType }} {{ item.extraMoney }}</div> -->
                                    <div v-if="item.bonusPercent" class="extra">+{{ item.bonusPercent }}%</div>
                                </div>
                                <div v-if="item.freePayNumber && usdtRepeatIsFreeRounds == 'Yes'" class="extra">+{{ item.freePayNumber }}FS</div>
                            </div>
                        </div>
                    </div>
                    <div class="how">
                        <div class="how-title">{{ $t("deposit.howTitle") }}</div>
                        <div class="how-step">{{ $t("deposit.Step") }} 1 - {{ $t("deposit.Deposit") }}</div>
                        <img src="@/assets/deposit/DepositNow.png" />
                        <div class="how-tips">{{ $t("deposit.howTips1") }}</div>
                        <div class="how-step">{{ $t("deposit.Step") }} 2 - {{ $t("deposit.Step2Title") }}</div>
                        <img src="@/assets/deposit/DepositBouns.png" />
                        <div class="how-tips">{{ $t("deposit.howTips2") }}</div>
                    </div>
                    <div class="btn" @click="toDeposit">{{ $t("deposit.Deposit") }}</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { getUserInfo } from '@/api/user'
import { getRechargeList } from '@/api/deposit'
import { Toast } from 'vant'
export default {
    name: 'depositRulesPopup',
    data() {
        return {
            show: false,
            userInfo: {},
            RechargeList: [],
            gratuityConditions: '',
            repeatIsFreeRounds: '',
            usdtList: [],
            usdtGratuityConditions: '',
            usdtRepeatIsFreeRounds: ''
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        }
    },
    created() { },
    methods: {
        close() {
            this.show = false
        },
        open() {
            getUserInfo().then(res1 => {
                if (res1.code) return
                this.userInfo = res1.result
                const grandRechargeNumber = Number(this.userInfo.grandRechargeNumber) + 1

                getRechargeList().then(res => {
                    if (res.code) {
                        Toast(res.message)
                        return
                    }
                    const D = res.result

                    this.RechargeList = []
                    this.rechargeGiftType = D.rechargeGiftType
                    this.rechargeGiftRewardType = D.rechargeGiftRewardType
                    this.repeatIsFreeRounds = D.repeatIsFreeRounds
                    if (this.rechargeGiftType === 'firstRecharge') {
                        this.RechargeList = D.firstRechargeDetailVoList
                        this.gratuityConditions = D.gratuityConditions
                    }
                    if (this.rechargeGiftType === 'repeatRecharge') {
                        this.RechargeList = D.everyRepeatRechargeDetailVoList
                        if (D && D.repeatRechargeNumberDetailVoList.length) {
                            if (D.repeatRechargeNumberDetailVoList.some(x => Number(x.rechargeNumber) === Number(grandRechargeNumber))) {
                                const repeatRechargeList = D.repeatRechargeNumberDetailVoList.filter(x => Number(x.rechargeNumber) === Number(grandRechargeNumber))[0]
                                this.RechargeList = repeatRechargeList.repeatRechargeDetailVoList
                                this.RechargeList.forEach(x => {
                                    x.isFreeRounds = repeatRechargeList.isFreeRounds
                                })
                            } else {
                                const repeatRechargeList = D.repeatRechargeNumberDetailVoList[D.repeatRechargeNumberDetailVoList.length - 1]
                                this.RechargeList = repeatRechargeList.repeatRechargeDetailVoList
                                this.showRepeatBouns = false
                            }
                        }
                    }
                    this.setRechargeList('RechargeList')

                    this.usdtList = []
                    this.usdtRechargeGiftType = D.usdtRechargeGiftType
                    this.usdtRechargeGiftRewardType = D.usdtRechargeGiftRewardType
                    this.usdtRepeatIsFreeRounds = D.usdtRepeatIsFreeRounds
                    if (this.usdtRechargeGiftType === 'firstRecharge') {
                        this.usdtList = D.usdtFirstRechargeDetailVoList
                        this.usdtGratuityConditions = D.usdtGratuityConditions
                    }
                    if (this.usdtRechargeGiftType === 'repeatRecharge') {
                        this.usdtList = D.usdtEveryRepeatRechargeDetailVoList
                        if (D && D.usdtRepeatRechargeNumberDetailVoList.length) {
                            if (D.usdtRepeatRechargeNumberDetailVoList.some(x => Number(x.rechargeNumber) === Number(grandRechargeNumber))) {
                                const repeatRechargeList = D.usdtRepeatRechargeNumberDetailVoList.filter(x => Number(x.rechargeNumber) === Number(grandRechargeNumber))[0]
                                this.usdtList = repeatRechargeList.repeatRechargeDetailVoList
                                this.usdtList.forEach(x => {
                                    x.isFreeRounds = repeatRechargeList.isFreeRounds
                                })
                            } else {
                                const repeatRechargeList = D.usdtRepeatRechargeNumberDetailVoList[D.usdtRepeatRechargeNumberDetailVoList.length - 1]
                                this.usdtList = repeatRechargeList.repeatRechargeDetailVoList
                                this.showUsdtRepeatBouns = false
                            }
                        }
                    }
                    this.setRechargeList('usdtList')
                })
            })
            this.show = true
            this.$nextTick(() => { })
        },
        setRechargeList(key) {
            this[key].forEach((item, i) => {
                if (this.rechargeGiftRewardType === 'immobilization') {
                    if (this.gratuityConditions === 'MAXIMUM' && (item.everyHandselRate || (this.userInfo && this.userInfo.everyFirstRechargeState === 'No' && item.handselRate) || (this.userInfo && this.userInfo.firstRechargeState === 'No' && item.firstHandselRate))) {
                        if (this.userInfo && this.userInfo.firstRechargeState === 'No') {
                            item.extraMoney = item.firstHandselRate > item.handselRate ? (item.firstHandselRate > item.everyHandselRate ? (item.firstHandselRate || 0).toFixed(2) : (item.everyHandselRate || 0).toFixed(2)) : (item.handselRate > item.everyHandselRate ? (item.handselRate || 0).toFixed(2) : (item.everyHandselRate || 0).toFixed(2))
                        } else if (this.userInfo && this.userInfo.everyFirstRechargeState === 'No') {
                            item.extraMoney = item.handselRate > item.everyHandselRate ? (item.handselRate || 0).toFixed(2) : (item.everyHandselRate || 0).toFixed(2)
                        } else {
                            item.extraMoney = (item.everyHandselRate || 0).toFixed(2)
                        }
                    } else if (item.everyHandselRate || (this.userInfo && this.userInfo.everyFirstRechargeState === 'No' && item.handselRate) || (this.userInfo && this.userInfo.firstRechargeState === 'No' && item.firstHandselRate)) {
                        if (this.userInfo && this.userInfo.firstRechargeState === 'No' && item.firstHandselRate) {
                            item.extraMoney = item.handselRate + item.firstHandselRate + item.everyHandselRate
                        } else if (this.userInfo && this.userInfo.everyFirstRechargeState === 'No' && item.handselRate) {
                            item.extraMoney = item.handselRate + item.everyHandselRate
                        } else {
                            item.extraMoney = (item.everyHandselRate || 0).toFixed(2)
                        }
                    }
                    if (item.extraMoney) item.bonusPercent = (Number(item.extraMoney) / Number(item.rechargeAmt) * 100).toFixed(2)
                } else {
                    if (this.gratuityConditions === 'MAXIMUM' && (item.everyHandselRate || (this.userInfo && this.userInfo.everyFirstRechargeState === 'No' && item.handselRate) || (this.userInfo && this.userInfo.firstRechargeState === 'No' && item.firstHandselRate))) {
                        if (this.userInfo && this.userInfo.firstRechargeState === 'No') {
                            item.bonusPercent = item.firstHandselRate > item.handselRate ? (item.firstHandselRate > item.everyHandselRate ? (item.firstHandselRate || 0).toFixed(2) : (item.everyHandselRate || 0).toFixed(2)) : (item.handselRate > item.everyHandselRate ? (item.handselRate || 0).toFixed(2) : (item.everyHandselRate || 0).toFixed(2))
                        } else if (this.userInfo && this.userInfo.everyFirstRechargeState === 'No') {
                            item.bonusPercent = item.handselRate > item.everyHandselRate ? (item.handselRate || 0).toFixed(2) : (item.everyHandselRate || 0).toFixed(2)
                        } else {
                            item.bonusPercent = (item.everyHandselRate || 0).toFixed(2)
                        }
                    } else if (item.everyHandselRate || (this.userInfo && this.userInfo.everyFirstRechargeState === 'No' && item.handselRate) || (this.userInfo && this.userInfo.firstRechargeState === 'No' && item.firstHandselRate)) {
                        if (this.userInfo && this.userInfo.firstRechargeState === 'No' && item.firstHandselRate) {
                            item.bonusPercent = item.handselRate + item.firstHandselRate + item.everyHandselRate
                        } else if (this.userInfo && this.userInfo.everyFirstRechargeState === 'No' && item.handselRate) {
                            item.bonusPercent = item.handselRate + item.everyHandselRate
                        } else {
                            item.bonusPercent = (item.everyHandselRate || 0).toFixed(2)
                        }
                    }
                    if (item.bonusPercent) item.extraMoney = (Number(item.bonusPercent) * Number(item.rechargeAmt) / 100).toFixed(2)
                }
            })
        },
        toDeposit() {
            this.close()
            this.$store.dispatch('user/setIsShowDepositPopup', true)
        }
    }
}
</script>

<style scoped lang="scss">
.popup {
    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .icon-close {
            width: 28px;
            height: 28px;
            background: var(--aurora-surface);
            border: 1px solid var(--aurora-line);
            border-radius: 50px;
            font-weight: 700;
            box-sizing: border-box;
            position: absolute;
            top: 10px;
            right: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 2;
            cursor: pointer;

            &>i {
                color: var(--aurora-ink);
                font-size: .22rem;
                vertical-align: middle;
            }
        }

        .content {
            border-radius: .32rem;
            background:
                var(--aurora-soft-gradient);
            border: 1px solid var(--aurora-line);
            box-shadow: 0 .18rem .36rem var(--aurora-shadow-color);
            width: 500px;
            max-height: 80vh;
            height: 700px;
            box-sizing: border-box;
            position: relative;
            overflow: auto;
            padding-bottom: 30px;
        }

        .header {
            height: 224px;
            background:
                var(--aurora-soft-gradient);
            border-radius: .32rem .32rem 0 0;
            overflow: hidden;

            .title {
                height: 110px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                font-size: 24px;
                color: var(--aurora-ink);
                font-weight: bold;

                &>.img {
                    width: 110px;
                    height: 100px;
                    padding: 15px;
                    margin-right: 15px;

                    &>img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .desc {
                background: var(--aurora-surface);
                border: 1px solid var(--aurora-line);
                border-radius: 10px;
                height: 130px;
                padding: 20px 2%;
                text-align: center;
                font-size: .28rem;
                color: var(--aurora-ink);
                box-sizing: border-box;
            }
        }

        .main-content {
            padding: 0 .28rem;
            padding-bottom: .8rem;

            .btn {
                display: block;
                width: 90%;
                margin: 4% auto 7%;
                margin-top: -20px;
                line-height: 40px;
                font-size: 14px;
                font-weight: bold;
                color: var(--aurora-on-primary);
                text-align: center;
                text-decoration: none;
                background: var(--aurora-primary-gradient);
                border-radius: .18rem;
                box-sizing: border-box;
                box-shadow: 0 .06rem .14rem var(--aurora-shadow-color);
            }

            .table {
                width: 100%;
                border: .01rem solid var(--aurora-line);
                margin-bottom: .2rem;
                background: var(--aurora-surface);

                .table-header {
                    background: var(--aurora-soft-gradient);
                    color: var(--aurora-ink);
                    text-align: center;
                    width: 100%;
                    display: flex;
                    align-items: center;

                    &>div:first-child {
                        height: 100%;
                        width: 60%;
                        padding: 10px;
                    }

                    &>div:nth-child(2) {
                        height: 100%;
                        width: 20%;
                        padding: 10px;
                    }

                    &>div:nth-child(3) {
                        height: 100%;
                        width: 20%;
                        padding: 10px;
                    }
                    &>div:last-child {
                        flex: 1;
                        height: 100%;
                        width: auto;
                        padding: 10px;
                    }
                }

                .table-body {
                    width: 100%;
                    color: var(--aurora-ink);

                    &>.tr {
                        display: flex;
                        align-items: center;
                        border-bottom: .01rem solid var(--aurora-line);

                        &>div:first-child {
                            height: 100%;
                            width: 60%;
                            border-right: .01rem solid var(--aurora-line);
                            padding: 10px;
                        }
                        &>div:nth-child(2) {
                            height: 100%;
                            width: 20%;
                            padding: 10px;
                        }

                        &>div:nth-child(3) {
                            height: 100%;
                            width: 20%;
                            padding: 10px;
                        }
                        &>div:last-child {
                            flex: 1;
                            height: 100%;
                            width: auto;
                            padding: 10px;
                        }

                        &:last-child {
                            border-bottom: none;
                        }
                    }
                }
            }

            .how {
                padding-bottom: 38px;

                .how-title {
                    font-weight: bold;
                    padding: 5px 2%;
                    text-align: center;
                    box-sizing: border-box;
                    color: var(--aurora-ink);
                }

                .how-step {
                    font-weight: bold;
                    background: var(--aurora-soft-gradient);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    text-align: center;
                    margin: 10% 0px 6% 0px;
                }

                &>img {
                    box-sizing: border-box;
                    height: auto;
                    max-width: 100%;
                }

                .how-tips {
                    font-weight: bold;
                    padding: 0px 2%;
                    text-align: center;
                    color: var(--aurora-muted);
                }
            }
        }

    }

    &.mobile {
        // width: 100% !important;
        // height: 100% !important;

        .van-popup {
            &.van-popup--center {
                top: 16vh;
                bottom: 0;
                left: 0;
                transform: translate3d(0, 0, 0);
                width: 100% !important;
                // height: 100% !important;
            }
        }

        .content {
            width: 100% !important;
            height: 100% !important;
            max-height: 100%;
            border-radius: 12px 12px 0 0 !important;
        }
    }
}
</style>
